import React, { useState } from "react";
import Modal from "react-modal";
import Index from "../about/index";
import { useLanguage } from "../../context/LanguageContext";

const HeroLight = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useLanguage();

  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  const heroContent = {
    heroImage: "img/stuff/halvanyitott.jpg",
    heroMobileImage: "img/stuff/kis_peter",
    heroLogo: "img/logo/Dyar_logo_fix.png",
    heroLogoMobile: "img/logo/dyar_mobil_logo.png",
    heroDescriptions:
      language === "hu"
        ? "Széleskörű szakmai tapasztalat és szakértelem az Ügyfeleink sikere érdekében."
        : "Extensive professional experience and expertise for the success of our clients.",
    heroBtn: language === "hu" ? "Kérjen ajánlatot" : "Request an Offer",
    modalTitle: language === "hu" ? "Rólunk" : "About",
    modalSubtitle: language === "hu" ? "Bemutatkozás" : "Resume",
    contactLink: language === "hu" ? "Kapcsolat" : "Contact",
  };

  return (
    <>
      <div className="row home-details-container align-items-center">
        <div
          className="col-lg-4 bg position-fixed d-none d-lg-block"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + heroContent.heroImage})`,
          }}
        ></div>
        <div className="col-12 col-lg-8 offset-lg-4 home-details  text-center text-lg-start">
          <div className="col-lg-2"></div>

          <div className="col-lg-8 logo-max">
            <img
              src={`${heroContent.heroLogo}`}
              className="img-fluid  d-none d-lg-block "
              alt="dyar-logo"
            />
          </div>
          <div className="text-center">
            <img
              src={`${heroContent.heroMobileImage}.jpg`}
              className="img-fluid main-img-mobile d-sm-block d-lg-none"
              alt="mobile-picture"
            />
            <img
              src={`${heroContent.heroLogoMobile}`}
              className="img-fluid d-sm-block d-lg-none mobile-dyar-logo"
              alt="dyar-mobile-logo"
            />

            <p className="open-sans-font header-text">
              {heroContent.heroDescriptions}
            </p>
            <a href={`#${heroContent.contactLink}`}>
              <button className="button">
                <span className="button-text">{heroContent.heroBtn}</span>
                <span className="button-icon fa fa-arrow-right"></span>
              </button>
</a>
          </div>
        </div>
      </div>
      {/* End home-details-container */}

      {/* Start Modal for About More */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark light"
        overlayClassName="custom-overlay"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src="/img/cancel.svg" alt="close icon" />
          </button>

          <div className="box_inner about green">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  {heroContent.modalTitle} <span>{language === "hu" ? "Mi" : "Us"}</span>
                </h1>
                <span className="title-bg">{heroContent.modalSubtitle}</span>
              </div>
              <Index />
            </div>
          </div>
        </div>
      </Modal>
      {/* End Modal */}
    </>
  );
};

export default HeroLight;
